export function formatNumber(intlShape, ...[value, formatOptions]) {
  return intlShape.formatNumber(value, formatOptions);
}